import { render, staticRenderFns } from "./VideoRoomChat.vue?vue&type=template&id=6ba7fc28&scoped=true"
import script from "./VideoRoomChat.vue?vue&type=script&lang=js"
export * from "./VideoRoomChat.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomChat.vue?vue&type=style&index=0&id=6ba7fc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7fc28",
  null
  
)

export default component.exports